module.exports = __webpack_public_path__ + "static/media/chess.893ce230.svg";